import { TTRow } from "primeng/treetable";

/**
 * Correctif PrimeNG 17.18.15 (dernière 17.x) — directive `ttRow` du TreeTable.
 *
 * `TTRow` écoute `keydown` sur le `<tr>` et traite les flèches/Home/End même quand la frappe
 * vient d'un champ de la ligne (inputs du chiffrage, nom de groupe…) : curseur bloqué, focus
 * volé, et sur flèche droite `findSingle(tr, 'button').style` plante si la ligne n'a pas de
 * bouton (Sentry EVA-FRONT-8M, /offers/:id/).
 *
 * Règle : la navigation clavier PrimeNG ne s'applique que si le `<tr>` lui-même a le focus,
 * et la flèche droite est ignorée sur une ligne sans bouton de dépliage.
 */
export function shouldSkipTreeTableRowKeydown(event: KeyboardEvent): boolean {
  const row = event.currentTarget as HTMLElement | null;
  if (!row || event.target !== row) return true;
  return event.code === "ArrowRight" && !row.querySelector("button");
}

export function patchPrimeNgTreeTableRow(): void {
  const original = TTRow.prototype.onKeyDown;
  TTRow.prototype.onKeyDown = function (this: TTRow, event: KeyboardEvent): void {
    if (shouldSkipTreeTableRowKeydown(event)) return;
    original.call(this, event);
  };
}
